import React from 'react';
import { aboutContent, backgroundImages } from '../data/mockData';

const AboutSection = () => {
  return (
    <section id="about" className="bg-white py-24">
      <div className="max-w-6xl mx-auto px-6">
        {/* About Header */}
        <div className="text-center mb-20">
          <h2 className="text-6xl md:text-7xl font-bold text-black tracking-[0.1em] mb-10" style={{ fontFamily: 'Georgia, serif' }}>
            ABOUT US
          </h2>
          <p className="text-gray-500 max-w-4xl mx-auto text-base leading-relaxed">
            {aboutContent.intro}
          </p>
        </div>

        {/* About Image */}
        <div className="mb-20">
          <img
            src={backgroundImages.about}
            alt="Cricket Training Facility"
            className="w-full h-[450px] object-cover"
          />
        </div>

        {/* Mission and What Sets Us Apart */}
        <div className="grid md:grid-cols-2 gap-0">
          {/* Our Mission */}
          <div
            className="relative h-[550px] bg-cover bg-center flex items-end"
            style={{
              backgroundImage: `url('${backgroundImages.mission}')`,
            }}
          >
            <div className="absolute inset-0 bg-black/50"></div>
            <div className="relative z-10 p-10 text-white">
              <h3 className="text-3xl font-bold mb-6 tracking-[0.1em]" style={{ fontFamily: 'Georgia, serif' }}>
                OUR MISSION:
              </h3>
              <p className="text-sm leading-relaxed opacity-90">
                {aboutContent.mission.text}
              </p>
            </div>
          </div>

          {/* What Sets Us Apart */}
          <div
            className="relative h-[550px] bg-cover bg-center flex items-end"
            style={{
              backgroundImage: `url('${backgroundImages.setsApart}')`,
            }}
          >
            <div className="absolute inset-0 bg-black/50"></div>
            <div className="relative z-10 p-10 text-white">
              <h3 className="text-3xl font-bold mb-6 tracking-[0.1em]" style={{ fontFamily: 'Georgia, serif' }}>
                WHAT SETS US APART:
              </h3>
              <p className="text-sm leading-relaxed opacity-90">
                {aboutContent.setsApart.text}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
